import React, { useState } from "react";
import { Table, Pagination, Form, InputGroup } from "react-bootstrap";
import {
    FaSearch,
    FaSort,
    FaSortUp,
    FaSortDown,
    FaTrash,
} from "react-icons/fa";
import "./viewTransaction.css"; // We'll create this CSS file
import NewPagination from "../NewPagination";

// import { formatTransactionType, toTitleCase } from "../../../Utils/helper";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import Confirmation_dialog from "../../confirmation_dialog";
const ViewTransaction = ({
    headers = [],
    data = [],
    onDelete,
    onSort,
    sortField,
    sortDirection,
    onSearch,
    page,
    totalPage,
    startIndex,
    endIndex,
    totalData,
    onPageChange,
}) => {
    //   Calculate pagination variables
    //   const totalItems = data.length;
    //   const totalPages = Math.ceil(totalItems / itemsPerPage);
    //   const startIndex = (currentPage - 1) * itemsPerPage;
    //   const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);
    const confirmDialogInitialState = {
        show: false,
        title: "",
        message: "",
        confirmText: "",
        cancelText: "",
        isConfirm: false,
        isDenied: false,
        data: "",
        onSuccess: () => { }
    };
    const [showConfirmDialog, setShowConfirmDialog] = useState(
        confirmDialogInitialState
    );
    const handleSort = (field) => {
        if (onSort) {
            onSort(field);
        }
    };

    const renderSortIcon = (field) => {
        if (sortField !== field) return <FaSort className="sort-icon" />;
        return sortDirection === "asc" ? (
            <FaSortUp className="sort-icon active" />
        ) : (
            <FaSortDown className="sort-icon active" />
        );
    };


    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {props}
        </Tooltip>
    );


    const handleConfirmDialogOpen = (message, confirmText, cancelText, data, onConfirm) => {
        setShowConfirmDialog((state) => ({
            ...state,
            show: true,
            message: toTitleCase(message),
            confirmText: confirmText,
            cancelText: cancelText,
            data: data,
            onSuccess: onConfirm
        }));
    };

    const handleConfirmDialogClose = () => {
        setShowConfirmDialog(confirmDialogInitialState);
    };

 function formatTransactionType(type) {
  if (!type) return type;
  if(typeof(type) !== String){
  
  // Replace all hyphens with spaces
  let formatted = type.replace(/-/g, ' ');
  
  // Capitalize first letter of each word
  formatted = formatted.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
  
  return formatted;
  }
}

    function toTitleCase(){
        
    }

    return (
        <div className="data-grid-container">
            {/* Search Input */}
            {onSearch && (
                <div className="grid-search mb-3">
                    <InputGroup>
                        <InputGroup.Text>
                            <FaSearch />
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            placeholder="Search..."
                            onChange={(e) => onSearch(e.target.value)}
                        />
                    </InputGroup>
                </div>
            )}

            {/* Table */}
            <div className="table-responsive">
                <Table striped bordered hover className="data-grid-table">
                    <thead>
                        <tr>
                            {headers.map((header, index) => (
                                <th
                                    key={index}
                                    onClick={() => handleSort(header.field)}
                                    className={header.field ? "sortable-header" : ""}
                                >
                                    <div className="header-content">
                                        {header.label}
                                        {header.field && renderSortIcon(header.field)}
                                    </div>
                                </th>
                            ))}
                            {onDelete && <th>Action</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {console.log("row", row)}
                                    {headers.map((header, colIndex) => {
                                        let cellValue = row[header.field] ?? "-";
                                        let style = {};

                                        // Conditionally apply text color for transactionType
                                        if (header.field === "transactionType") {
                                            if (cellValue === "Manual-Website-Withdraw" || cellValue === "Withdraw" || cellValue === "Manual-Bank-Withdraw" || cellValue === "Bank-To-Bank Withdraw") {
                                                style.color = "red";
                                                cellValue = formatTransactionType(cellValue)
                                            } else if (cellValue === "Manual-Website-Deposit" || cellValue === "Deposit" || cellValue === "Manual-Bank-Deposit" || cellValue === "Bank-To-Bank Deposit") {
                                                style.color = "green";
                                                cellValue = formatTransactionType(cellValue)
                                            }
                                        }

                                        if (header.field === "transactionType") {
                                            console.log("cellValue", cellValue);
                                            const fullValue = cellValue;

                                            return (
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip(fullValue)}
                                                >
                                                    <td key={colIndex} style={{ ...style, cursor: 'help' }} >
                                                        {cellValue}
                                                    </td>
                                                </OverlayTrigger>
                                            );
                                        }

                                        if (header.field === "remarks") {
                                            const fullValue = cellValue;
                                            const displayValue = fullValue.length > 20 ? `${fullValue.substring(0, 20)}...` : fullValue;

                                            return (
                                                <OverlayTrigger
                                                    placement="bottom"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip(fullValue)}
                                                >
                                                    <td key={colIndex} style={{ ...style, cursor: 'help' }} >
                                                        {displayValue}
                                                    </td>
                                                </OverlayTrigger>
                                            );
                                        }

                                        return (
                                            <td key={colIndex} style={style}>
                                                {cellValue}
                                            </td>
                                        );
                                    })}
                                    {onDelete && (
                                        <td>
                                            <button
                                                className="btn btn-sm text-white"
                                                style={{ backgroundColor: "#4682b4" }}
                                                // onClick={() => onDelete(row.transactionId, row.transactionType)}
                                                onClick={() => {
                                                    handleConfirmDialogOpen(
                                                        "are you sure you want to delete ?",
                                                        "Yes",
                                                        "Cancel",
                                                        "",
                                                        () => onDelete(row.transactionId, row.transactionType)
                                                    );
                                                }}
                                                title="Delete"
                                                disabled={row.isDeleted}
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={headers.length + (onDelete ? 1 : 0)}
                                    className="text-center"
                                >
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {data.length > 0 && (
                <NewPagination
                    currentPage={page}
                    totalPages={totalPage}
                    handlePageChange={onPageChange}
                    startIndex={startIndex}
                    endIndex={endIndex}
                    totalData={totalData}
                />
            )}
                  {/* <Confirmation_dialog
                    show={showConfirmDialog.show}
                    title={showConfirmDialog.title}
                    message={showConfirmDialog.message}
                    confirmText={showConfirmDialog.confirmText}
                    cancelText={showConfirmDialog.cancelText}
                    state={showConfirmDialog}
                    onSuccess={showConfirmDialog.onSuccess}
                    handleConfirmDialogClose={handleConfirmDialogClose}
                  /> */}
        </div>
    );
};

export default ViewTransaction;
